import { ReactNode } from 'react';
import { cn } from 'utils/cn';

interface InfoCardProps {
  label: ReactNode;
  value: ReactNode;
  className?: string;
}

const InfoCard = ({ label, value, className }: InfoCardProps) => {
  return (
    <div
      className={cn(
        'bg-white p-3 border border-border rounded shadow-sm',
        className
      )}
    >
      <div className="text-xs font-medium text-gray-500 mb-2">{label}</div>
      <div className="font-medium">{value}</div>
    </div>
  );
};

export default InfoCard;
